import * as html from 'smg/html';

interface myWindow extends Window {
    readonly jumpToTopBtn: boolean;
}

declare const window: myWindow;
export const JumpToTopBtn = window.jumpToTopBtn;

const button = html.FromString('<a id="jump-to-top" href="#" class="btn btn-white shadow-lt-1"><span class="material-symbols-rounded">keyboard_arrow_up</span><span class="jtt-btn-text"></span></a>');

if (JumpToTopBtn) {
    // Default distances
    let distanceFromRight = 32;
    let distanceFromBottom = 16;

    // Figure out the position of the podium button so we can place the jump-to-top button beside it
    const getDistances = () => {
        const podiumFrame = document.querySelector<HTMLIFrameElement>('#podium-website-widget iframe[id$="bubble"]');
        const podiumBody = podiumFrame?.contentDocument?.body;
        const podiumButton = podiumBody?.querySelector<HTMLButtonElement>('.ContactBubble');

        if (podiumFrame && podiumButton) {
        // Calculate the distance from the right edge of the screen to the left edge of the podium button
            const frameBounds = podiumFrame.getBoundingClientRect();
            const buttonBounds = podiumButton.getBoundingClientRect();

            const podiumBtnLeftEdge = frameBounds.left + buttonBounds.left;
            const podiumBtnLeftEdgeDistanceFromRight = window.innerWidth - podiumBtnLeftEdge;

            distanceFromRight = podiumBtnLeftEdgeDistanceFromRight + 16; // add gap
            if (button.style.getPropertyValue('--distance-from-right') !== `${distanceFromRight}px`) {
                const transition = button.style.transition;
                button.style.transition = 'none';
                button.style.setProperty('--distance-from-right', `${distanceFromRight}px`);
                setTimeout(() => button.style.transition = transition);
            }

            // Calculate the distance from the bottom of the screen to the centerline of the podium button
            // We'll set the bottom position of the jump-to-top button to this distance, offset by half the height of the button.
            const podiumBtnBottomEdge = frameBounds.top + buttonBounds.bottom;
            const podiumBtnBottomEdgeDistanceFromBottom = window.innerHeight - podiumBtnBottomEdge;
            distanceFromBottom = podiumBtnBottomEdgeDistanceFromBottom + (buttonBounds.height / 2) - (button.offsetHeight / 2);
            button.style.setProperty('--distance-from-bottom', `${distanceFromBottom}px`);
        } else {
            button.style.setProperty('--distance-from-right', '32px');
            button.style.setProperty('--distance-from-bottom', '24px');
        }

        setTimeout(getDistances, 10);
    };

    getDistances();

    button.style.setProperty('--distance-from-right', `${distanceFromRight}px`);
    button.style.setProperty('--distance-from-bottom', `${distanceFromBottom}px`);

    button.style.setProperty('bottom', '-100px');

    let buttonVisible = false;
    const updateBtn = () => {
        // Check if we need to change the visibility, so we only manipulate the DOM when necessary
        if (document.body.scrollTop > 200 === buttonVisible) {
            return;
        }

        if (document.body.scrollTop > 200) {
            buttonVisible = true;
            button.style.setProperty('bottom', 'var(--distance-from-bottom)');
        } else {
            buttonVisible = false;
            button.style.setProperty('bottom', '-100px');
        }
    };

    // This event fires suuuper frequently so we should throttle it
    let throttle = false;
    document.body.addEventListener('scroll', () => {
        if (!throttle) {
            throttle = true;
            setTimeout(() => throttle = false, 100);
            updateBtn();
        }
    });
    document.body.addEventListener('scrollend', () => {
        // Because of the throttling, it's possible to scroll to the top fast enough that the button doesn't show up.
        // To prevent this, we'll make sure the update function is called at least once when the scroll ends.
        updateBtn();
    });

    button.addEventListener('click', e => {
        e.preventDefault();
        document.body.scrollTo({ top: 0, behavior: 'smooth' });
    });

    document.body.appendChild(button);
}
